<template>
  <div class="seller" ref="sellerRef">
    <h3>Seller Application</h3>
    <a-form>
      <a-form-item 
        v-bind="validateInfos.companyName"
      >
        <div class="input">
          <span>Company Name</span>
          <artmisads-input v-model:value="modelRef.companyName" />
        </div>
      </a-form-item>
      <a-form-item
        v-bind="validateInfos.websiteOrStorefront"
      >
        <div class="input" style="margin-top: 32px;">
          <span>Website or Amazon Storefront</span>
          <artmisads-input v-model:value="modelRef.websiteOrStorefront"/>
        </div>
      </a-form-item>
      <a-form-item
        v-bind="validateInfos.referralSource"
      >
        <div class="input">
          <span>How did you hear about us?</span>
          <artmisads-select
            v-model:value="modelRef.referralSource"
            style="width: 480px;"
            size="large"
            :options="HEAR_ABOUT_US_ARR"
          />
        </div>
      </a-form-item>
      <a-form-item v-bind="validateInfos.agreeTermsConditions">
        <div class="terms-conditions">
          <a-checkbox v-model:checked="modelRef.agreeTermsConditions">I agree to the </a-checkbox><a target="_blank" href="/terms-of-service">Terms of Services</a><span> | </span><a target="_blank" href="/privacy-policy">Privacy Policy</a>
        </div>
      </a-form-item>
    </a-form>
   
    <div class="amazon">
      <p class="text-first">Finish the sign up process by connecting your Amazon account.</p>
      <p class="text-second">Please connect using the email address with broad Seller/Vendor Central permissions to ensure all of your brands and products are imported correctly.</p>
      <div class="content">
          <a id="LoginWithAmazon" @click.prevent="onSubmit">
            <img border="0" alt="Login with Amazon"
                src="http://g-ecx.images-amazon.com/images/G/01/lwa/btnLWA_gold_312x64._CB372226922_.png"
                 />
          </a>
        <artmisads-select
          style="width: 160px"
          :getPopupContainer="() => sellerRef"
          v-model:value="amazonCountryCode"
        >
          <a-select-option value="US" label="US">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guoqi-us"></use>
            </svg>
            <span>US</span>
          </a-select-option>
          <a-select-option value="UK" label="UK">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guoqi-uk"></use>
            </svg>
            <span>UK</span>
          </a-select-option>
          <a-select-option value="CA" label="CA">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guoqi-ca"></use>
            </svg>
            <span>CA</span>
          </a-select-option>
          <a-select-option value="DE" label="DE">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guoqi-de"></use>
            </svg>
            <span>DE</span>
          </a-select-option>
          <a-select-option value="FR" label="FR">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-guoqi-fr"></use>
            </svg>
            <span>FR</span>
          </a-select-option>
        </artmisads-select>
      </div>
    </div>
    <div id="amazon-root"></div>
  </div>
</template>
<script setup>
  import { ref, onMounted, reactive } from 'vue';
  import { useRoute } from 'vue-router';
  import { Form } from 'ant-design-vue';

  import { HEAR_ABOUT_US} from '../../contants/signUp';
  import signApi from '~/server/sign';

  const HEAR_ABOUT_US_ARR = HEAR_ABOUT_US.map(item => ({
    label: item,
    value: item
  }));

  const sellerRef = ref();
  const useForm = Form.useForm;
  const props = defineProps(['goTo']);
  const route = useRoute();
  const amazonCode = route.query.code;

  const amazonCountryCode = ref('US');

  const modelRef = reactive({
    companyName: '',
    websiteOrStorefront: '',
    referralSource: '',
    agreeTermsConditions: false
  });

  const rulesRef = reactive({
    companyName: [{
      required: true,
      message: 'Company name cannot be empty',
    }],
    websiteOrStorefront: [{
      required: true,
      message: 'Must be a valid URL',
    }],
    referralSource: [{
      required: true,
      message: 'You must select an option',
    }],
    agreeTermsConditions: [{
      required: true,
      validator: validateAgreeTermsConditions,
      trigger: 'change',
    }],
  });

  const { validate, validateInfos } = useForm(modelRef, rulesRef);

  function validateAgreeTermsConditions  (_rule, value) {
    if (!value) {
      return Promise.reject('You must agree to the terms & conditions');
    } else {
      return Promise.resolve();
    }
  };

  onMounted(() => {
    amazonLoginInitialize();
  })

  function amazonLoginInitialize () {
    const CLIENT_ID = 'amzn1.application-oa2-client.d1775637c50f46d4b039895ab42f2dda';
    window.onAmazonLoginReady = function() {
      amazon.Login.setClientId(CLIENT_ID);
      // amazon.Login.logout();
    };
    (function(d) {
      var a = d.createElement('script'); a.type = 'text/javascript';
      a.async = true; a.id = 'amazon-login-sdk';
      a.src = 'https://assets.loginwithamazon.com/sdk/na/login1.js';
      d.getElementById('amazon-root').appendChild(a);
    })(document);
  }

  function setProfile () {
    const params = {
      sellerProfile: {
        amazonAuthorizationCode: amazonCode,
        ...modelRef,
        amazonCountryCode: amazonCountryCode.value,
      },
      userType: 'seller'
    }
    localStorage.setItem('userProfile', JSON.stringify(params));
  }

  function onSubmit () {
    validate()
    .then(res => {
      if (!res.errorFields) {
        setProfile();
        const options = {};
        options.scope = 'advertising::campaign_management profile';
        options.response_type = 'code';
        signApi.amazonLoginIntoTracking()
        amazon.Login.authorize(options, `${location.origin}/profile`);
        return false;
      }
    })
  }

</script>
<style lang="less" scoped>
  .seller{
    display: flex;
    flex-direction: column;
    .input {
      display: flex;
      flex-direction: column;
      margin-top: 24px;
      width: 480px;
      > span {
        color: var(--dark-2);
        height: 16px;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 8px;
      }
    }
    .terms-conditions {
      margin-top: 24px;
      label {
        font-weight: 400;
        color: var(--dark-3);
      }
      span, a {
        color: var(--dark-3);
        font-size: var(--font-size-small);
        line-height: 18px;
        text-align: left;
      }
      a {
        text-decoration: underline;
      }
      
    }
    .amazon {
      margin-top: 40px;
      height: 150px;
      background: var(--color-white);
      box-shadow: var(--section-box-shadow-2);
      border-radius: 8px;
      padding: 16px;
      .text-first {
        height: 18px;
        font-size: var(--font-size-small);
        line-height: 18px;
        font-weight: 500;
      }
      .text-second {
        margin-top: 4px;
        width: 448px;
        height: 48px;
        font-family: Sora, sans-serif;
        font-size: var(--font-size-min);
        color: var(--dark-2);
        line-height: 16px;
      }
      .content {
        margin-top: 8px;
        display: flex;
        > a {
          width: 195px;
          height: 40px;
          border-radius: 2px;
          text-align: center;
          margin-right: 8px;
          > img {
            width: 193px;
            height: 40px;
          }
        }
        :deep(.ant-select-selector) {
          height: 40px;
          .ant-select-selection-item {
            display: flex;
            > svg {
              min-width: 24px;
              width: 24px;
              height: 24px;
              margin-right: 8px;
              align-self: center;
            }
            > span {
              font-weight: 400;
              font-size: var(--font-size-large);
              line-height: 38px;
            }
          }
        }
      }
    }
    :deep(.ant-form) {
      .ant-form-item {
        margin-bottom: 0;
      }
    }
    :deep(.ant-select-item-option-content) {
      display: flex;
      > svg {
        width: 24px;
        height: 24px;
        align-self: center;
        margin-right: 12px;
      }
    }
  }
  
</style>